import { render, staticRenderFns } from "./CowsPtPurchaseForm.vue?vue&type=template&id=d5f62442&scoped=true&"
import script from "./CowsPtPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./CowsPtPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f62442",
  null
  
)

export default component.exports